import React from "react";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import { Button, Result } from "antd";
import { useTranslation } from "react-i18next";
import { useAuth } from "shared/contexts/AuthProvider";
import { useUserOrg } from "shared/contexts/UserOrgContext";
import { hasAnyOrgRole } from "shared/utils/orgRoles";

/**
 * Route guard.
 *
 * Props:
 *  - requiredRoles    — legacy global-role list. Currently NOT enforced (kept
 *                       as-is so existing routes keep their behaviour).
 *  - requiredOrgRoles — org-role list, e.g. ["log_manager"]. Access is granted
 *                       to superusers, or to users holding ANY of these roles in
 *                       the currently selected organization (UserOrgContext).
 *                       Authenticated users without the role see a 403 page
 *                       (not a redirect to /login). While the org list is still
 *                       being fetched a loading placeholder is shown instead.
 */
export const RequiresAuth = ({ children, requiredRoles, requiredOrgRoles }) => {
  const { auth, setError, loading, isSuperUser } = useAuth();
  const userOrg = useUserOrg();
  const location = useLocation();

  const checkPermission = (auth, requiredRoles) => {
    if (!auth.isAuth) {
      setError("");
      return false;
    }
    return true; //temporary, always allow access
    // if (requiredRoles == null || requiredRoles.length == 0) return true;
    // if (auth.roles == null) {
    //   console.log("null roles");
    // }

    // for (let a in auth.roles) {
    //   for (let r in requiredRoles)
    //     if (auth.roles[a] == requiredRoles[r]) {
    //       return true;
    //     }
    // }

    // setError(
    //   "Access denied! Please login again using an authorized user roles: " +
    //     requiredRoles
    // );
    // return false;
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!checkPermission(auth, requiredRoles)) {
    return <Redirect to={{ pathname: "/login", state: { from: location } }} />;
  }

  if (requiredOrgRoles && requiredOrgRoles.length > 0) {
    // Org list not fetched yet for this session: don't judge roles against an
    // empty list (would flash a 403 right after login / page reload).
    const orgsReady = userOrg?.ready ?? true;
    if (!orgsReady) {
      return <div>Loading...</div>;
    }
    const allowed = hasAnyOrgRole(
      { isSuperUser, hasRoleInSelectedOrg: userOrg?.hasRoleInSelectedOrg },
      requiredOrgRoles,
    );
    if (!allowed) {
      return <AccessDenied />;
    }
  }

  return children;
};

const AccessDenied = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Result
      status="403"
      title={t("common.accessDenied")}
      subTitle={t("common.accessDeniedOrgRole")}
      extra={
        <Button type="primary" onClick={() => history.push("/dashboard")}>
          {t("common.backToDashboard")}
        </Button>
      }
    />
  );
};
